export default {
  meta: {
    title: '类目管理',
  },
};
